
<script>

import LoginService from './LoginService.js'

export default {
  data () {
    return {
      
    }
  },
  methods: {

        logUserOut: function(){
            LoginService.logUserOut();

            
        }
  }, 
  created(){ this.logUserOut(); },

  
}

</script>








// WEBPACK FOOTER //
// src/components/Logout.vue